// client/extensions/Bold.ts
import { mergeAttributes } from "@tiptap/core";
import TiptapBold from "@tiptap/extension-bold";
var BoldTranslations = { bold: { tooltip: ["Fett", "Bold"] } };
var BoldExtension = TiptapBold.extend({
  addOptions() {
    return {
      tagName: "b",
      HTMLAttributes: {}
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [this.options.tagName, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  parseHTML() {
    return [
      {
        tag: this.options.tagName
      },
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (node) => node.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
      }
    ];
  },
  addAttributes() {
    return {
      inline: { default: "" }
    };
  }
});
var Bold = {
  buttons: ({ editor, host }) => [
    {
      name: "toggleBold",
      icon: "format_bold",
      action: () => editor.chain().focus().toggleBold().run(),
      tooltip: host.translator.translate("tiptap", "bold", "tooltip")
    }
  ],
  extensions: [BoldExtension]
};
export {
  Bold,
  BoldExtension,
  BoldTranslations
};
